import React, { useCallback, useState } from 'react';
import { Div } from '@pinpoint/design-kit';
import { useDispatch } from 'react-redux';

import { ModelProp } from 'src/store/typings';
import { FairnessClassDropdown } from 'src/components/dropdown';
import CONSTANTS from 'src/store/constants';
import { appActions, modelViewActions } from 'src/store/actions';

import { MinAIRInput, MaxAIRInput } from './interactables';
import { AirButtonGroup, RemediateButton } from './buttons';
import Infographic from './infographic';

export default function ClassifierMode({ model }) {
  const dispatch = useDispatch();
  // State
  const [demoSelection, setDemoSelection] = useState(0);
  const [classIndex, setClassIndex] = useState(0);
  const [minVal, setMinVal] = useState(0.83);
  const [maxVal, setMaxVal] = useState(1.2);

  // Handlers
  const processInput = useCallback(
    (evt) => {
      evt.preventDefault();
      const { target } = evt;
      const { value: trial, id: iptId } = target;
      if (iptId === 'max-val') setMaxVal(+trial);
      if (iptId === 'min-val') setMinVal(+trial >= maxVal ? maxVal - 0.01 : +trial);
    },
    [maxVal]
  );
  const handleRemediateTrigger = useCallback(() => {
    dispatch(
      modelViewActions.remediateModel(model.id, CONSTANTS.TAL_MODEL.FAIRNESS_CLASSES[classIndex], minVal, maxVal)
    );
    dispatch(appActions.enqueueNotification('Starting remediation of model.', { autoClose: true, timeout: 5000 }));
  }, [classIndex, dispatch, maxVal, minVal, model.id]);

  // Effects

  return (
    <Div
      bg="white"
      rounded="md"
      overflow="hidden"
      d="flex"
      flexDir="column"
      data-test="paper"
      minH="0px"
      h="100%"
      maxH="100%"
      minW="0px"
      w="100%"
      maxW="100%"
      p={{ t: '2rem', x: '2rem' }}
      textSize="input"
      textWeight="500"
    >
      <AirButtonGroup classifier selected={demoSelection} handleSelection={setDemoSelection} />
      <Div flexGrow="1" d="grid">
        <Infographic
          model={model}
          showPricing={false}
          showValue={false}
          demoIndex={demoSelection}
          minVal={minVal}
          maxVal={maxVal}
        />
      </Div>
      <Div textColor="shade33" m={{ y: '.5rem' }} d="flex" align="center" justify="center">
        <Div tag="span">Ensure that the AIRs for</Div>
        <Div m="0.5rem" w="8rem">
          <FairnessClassDropdown onSelection={setClassIndex} classIndex={classIndex} />
        </Div>
        remain between
        <MinAIRInput value={minVal} onChange={processInput} />
        and
        <MaxAIRInput value={maxVal} onChange={processInput} />
        <RemediateButton disabled={false} onClick={handleRemediateTrigger} />
      </Div>
    </Div>
  );
}

ClassifierMode.propTypes = {
  model: ModelProp.isRequired,
};
